const config = {
  isProd: process.env.NODE_ENV === "production",
  apiBase: process.env.REACT_APP_API_ENDPOINT,
  resourceBaseWomen: process.env.REACT_APP_RESOURCE_BASEURL_W,
  resourceBaseMen: process.env.REACT_APP_RESOURCE_BASEURL_M,
  cmsEndpointWomen: process.env.REACT_APP_CMS_ENDPOINT_W,
  cmsEndpointMen: process.env.REACT_APP_CMS_ENDPOINT_M,
  baseUrlWomen: process.env.REACT_APP_BASEURL_W,
  baseUrlMen: process.env.REACT_APP_BASEURL_M,
  ver: process.env.REACT_APP_VERSION,
  updateDate: process.env.REACT_APP_UPDATED_AT
}

console.log(process.env, config)
export default {
  ...config
}